export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '快速导航',
      items: [
        { label: '联系咨询', href: '#contact' },
        { label: '平台优势', href: '#features' },
        { label: '精彩预告', href: '#media' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '内容分类',
      items: [
        { label: '最新电影', href: '#cards' },
        { label: '热播榜单', href: '#ranking' },
        { label: '热门话题', href: '#topics' },
        { label: '主题索引', href: '#index' },
      ],
    },
    {
      title: '关于我们',
      items: [
        { label: '平台介绍', href: '#about' },
        { label: '最新动态', href: '#updates' },
        { label: '手机观看', href: '#app' },
        { label: '观众评论', href: '#comments' },
      ],
    },
  ];

  const handleClick = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        {/* Main footer content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-lg font-bold text-white whitespace-nowrap">
                春夜影院
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              春夜影院提供免费高清电影电视剧在线观看，蓝光画质不缓冲流畅播放。覆盖最新电影、热播剧集、综艺娱乐，支持手机版便捷访问，随时随地畅享影视盛宴。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={handleClick('#hero')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-home-4-line text-base"></i>
              </a>
              <a href="#contact" onClick={handleClick('#contact')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-mail-line text-base"></i>
              </a>
              <a href="#app" onClick={handleClick('#app')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-smartphone-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      onClick={handleClick(item.href)}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Partners area */}
        <div className="border-t border-background-700 pt-8 mb-8">
          <h4 className="font-heading text-sm font-semibold text-foreground-300 mb-3">
            合作伙伴
          </h4>
          <p className="text-xs text-foreground-500">
            如有合作意向，欢迎通过「联系咨询」模块与我们取得联系。
          </p>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 春夜影院 ChunYe.tv 版权所有。本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#faq" onClick={handleClick('#faq')} className="hover:text-foreground-300 transition-colors duration-200 cursor-pointer">常见问题</a>
            <a href="#about" onClick={handleClick('#about')} className="hover:text-foreground-300 transition-colors duration-200 cursor-pointer">关于我们</a>
            <a href="#contact" onClick={handleClick('#contact')} className="hover:text-foreground-300 transition-colors duration-200 cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}